import { useWorkspace } from '../hooks/useWorkspace';
import { useAuth } from '../hooks/useAuth';
import { FRAMEWORKS, REGIONS, en } from '@seedgovernance/shared';

export function Dashboard() {
  const { user } = useAuth();
  const { currentWorkspace } = useWorkspace();

  if (!currentWorkspace || !user) return null;

  const region = REGIONS[currentWorkspace.region as keyof typeof REGIONS];

  return (
    <div className="space-y-6">
      {/* Welcome header */}
      <div>
        <h1 className="text-2xl font-display font-bold text-white">
          {currentWorkspace.companyName}
        </h1>
        <p className="text-slate-400 text-sm mt-1">
          Welcome back, {user.name}
        </p>
      </div>

      {/* Stats row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Frameworks" value="0" subtitle="Active" />
        <StatCard label="Deliverables" value="0" subtitle="Total" />
        <StatCard label="Completion" value="0%" subtitle="Overall" />
        <StatCard label="Exportable" value="0" subtitle="Documents" />
      </div>

      {/* Workspace info */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-surface-mid rounded-xl p-6 border border-border">
          <h2 className="text-lg font-display font-semibold text-white mb-4">
            Active Frameworks
          </h2>
          <div className="text-slate-400 text-sm">
            No frameworks activated yet. Go to{' '}
            <span className="text-brand-light">Frameworks</span> to get started.
          </div>
        </div>

        <div className="bg-surface-mid rounded-xl p-6 border border-border">
          <h2 className="text-lg font-display font-semibold text-white mb-4">
            Workspace Info
          </h2>
          <dl className="space-y-3 text-sm">
            <div>
              <dt className="text-slate-500">Region</dt>
              <dd className="text-white">{region?.label || currentWorkspace.region}</dd>
            </div>
            <div>
              <dt className="text-slate-500">Role</dt>
              <dd className="text-white capitalize">{currentWorkspace.role}</dd>
            </div>
            <div>
              <dt className="text-slate-500">Plan</dt>
              <dd className="text-white">Trial</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}

function StatCard({
  label,
  value,
  subtitle,
}: {
  label: string;
  value: string;
  subtitle: string;
}) {
  return (
    <div className="bg-surface-mid rounded-xl p-5 border border-border">
      <p className="text-slate-400 text-xs uppercase tracking-wider mb-1">
        {label}
      </p>
      <p className="text-2xl font-display font-bold text-white">{value}</p>
      <p className="text-slate-500 text-xs mt-1">{subtitle}</p>
    </div>
  );
}
